/*
only for home and menu
*/

import {
    SET_LOADING,
    SET_ERROR,
    SET_SUCCESS,
    CLEAR_ERROR,
} from '../mutation-types';
import axios from 'axios';
import { ApiContactUs } from '../../.env';

export default {
    /**
     * States
     */
    state: {
        items: [],
    },

    /**
     * Mutations
     */
    mutations: {
        setItems(state, payload) {
            // console.log('setItems', payload);
            state.items = payload;
        }
    },

    /**
     * Getters
     */
    getters: {
        // items: state => state.items,
        items (state) {
            return state.items;
        }
    },

    /**
     * Actions
     */
    actions: {
        fetchItems({ commit }, payload) {
            // console.log('store home: ', payload); // payload is the endpoint

            commit(SET_LOADING, true);
            commit(CLEAR_ERROR);
            axios.get(payload)
                .then((response) => {
                    commit(SET_LOADING, false);
                    commit('setItems', response.data);
                    let title;
                    let description;
                    let keywords;

                    if(response.data.metas !== undefined) {
                        title = response.data.metas.meta_title;
                        description = response.data.metas.meta_description;
                        keywords = response.data.metas.meta_keywords;
                    }
                    if(response.data.settings !== undefined) {
                        commit('setLat', response.data.settings.lat);
                        commit('setLng', response.data.settings.lng);
                    }

                    // console.log('should metas: ', title, description, keywords);

                    document.title = title;
                    document.head.querySelector('meta[name=description]').content = description;
                    document.head.querySelector('meta[name=keywords]').content = keywords;
                    // console.log('home store items: ', this.getters.items, response.data);

                })
                .catch((error) => {
                    commit(SET_LOADING, false);
                    commit(SET_ERROR, error);
                    // console.log('Home STORE error fetching items: ', error);
                });
        },

        sendMail({ commit }, payload) {
            // console.log('SEND Mail ???: ', payload);
            commit(SET_LOADING, true);
            commit(CLEAR_ERROR);

            axios.post(ApiContactUs, payload).then((response) => {
                commit(SET_LOADING, false);
                // commit(SET_REGISTERED_USER, payload);
                // console.log('response: ', response.data);
                if(response.data.success === 0) {
                    commit(SET_ERROR, response.data.message);
                } else{
                    commit(SET_SUCCESS, response.data.success);
                }
            }).catch((error) => {
                commit(SET_LOADING, false);

                commit(SET_ERROR, error.response);
                // console.log('error on send message: ', error);

            });
        },
    },

    //---------------- end export
};




// WEBPACK FOOTER //
// ./src/store/modules/home.js